import React from "react"
import Container from "./Container"
import Button from "./Button"
import { motion } from "framer-motion"
import { cardVariants } from "../utils/animations"
import { navigate } from "gatsby"
import Banner from "./Banner/Banner"
import { useLocation } from "@reach/router"
import partner_badge_banner from "../images/partner_badge_banner.svg"
import partner_chevron_banner from "../images/partner_chevron_banner.svg"
// import { StaticImage } from "gatsby-plugin-image";

function Hero({
  content,
  image,
  casestudy,
  primaryBtnText = "Talk to sales",
  secondaryBtnText = "Explore our case studies",
  primaryLink = "/contactus",
  secondaryLink = "/case-studies",
}) {
  const location = useLocation()

  const banner_content = {
    image: partner_badge_banner,
    text: "2024 AWS EMEA Rising Star Consulting Partner of the Year 🎉",
    icon: partner_chevron_banner,
  }
  return (
    <Container>
      <motion.div
        variants={cardVariants}
        initial="offscreen"
        whileInView="onscreen"
        viewport={{ once: true, amount: 0.3 }}
        className=" z-1 bg-transparent my-16 py-10 px-2 md:px-5 lg:px-10 pb-[200px] pt-[150px]"
      >
        {location.pathname === "/" && <Banner content={banner_content} />}
        <p className="hidden sm:block font-[700] text-[24px] md:text-[36px] lg:text-[48px] text-center text-[#121212] mb-[24px]">
          {content.primaryTitle} {content.secondaryTitle}
        </p>
        <p className=" sm:hidden font-[700] text-[24px] md:text-[36px] lg:text-[48px] text-center text-[#121212] mb-[24px]">
          {content.primaryTitle}
          <br />
          {content.secondaryTitle}
        </p>
        <p className="quicksand text-[#666666] font-light text-[14px] md:text-[18px] lg:text-[20px] text-center w-full md:w-10/12 mx-auto mb-[48px] ">
          {content.description}
        </p>

        <div className="flex gap-4  w-[90%] md:w-[70%] lg:w-full mx-auto flex-col md:flex-row justify-center">
          <div>
            <Button onClick={() => navigate(primaryLink)}>
              {primaryBtnText}
            </Button>
          </div>
          {!casestudy && (
            <div>
              <Button onClick={() => navigate(secondaryLink)} outline>
                {secondaryBtnText}
              </Button>
            </div>
          )}
        </div>
      </motion.div>
      {image && (
        <motion.div
          initial={{ y: "200px", opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.8 }}
          variants={cardVariants}
        >
          <div className="hidden md:block -mt-[200px] pb-[300px]">
            <img src={image[0]} alt="" />
            {/* <GatsbyImage src={image[0]} alt="A dinosaur" /> */}
          </div>
          <div className="flex justify-center md:hidden mb-[100px] -mt-[200px]">
            <img src={image[1]} alt="" />
            {/* <StaticImage src={image[1]} alt="A dinosaur" /> */}
          </div>
        </motion.div>
      )}
    </Container>
  )
}

export default Hero
